import React from 'react';

// This component defines custom CSS classes for form elements
const FormStyles = () => {
  return (
    <style jsx global>{`
      /* Custom form input styling */
      .input-field {
        @apply w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500;
      }
      
      /* Button styles */
      .btn {
        @apply px-4 py-2 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors;
      }
      
      .btn-primary {
        @apply bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500;
      }
      
      .btn-outline {
        @apply border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-primary-500;
      }
      
      .btn-secondary {
        @apply bg-secondary-600 text-white hover:bg-secondary-700 focus:ring-secondary-500;
      }
      
      /* Select dropdown styling */
      select.input-field {
        @apply pr-10 bg-white;
      }
      
      /* Checkbox and radio styling */
      input[type="checkbox"], input[type="radio"] {
        @apply h-4 w-4 text-primary-600 focus:ring-primary-500 rounded border-gray-300;
      }
      
      /* Form groups */
      .form-group {
        @apply mb-4;
      }
      
      /* Labels */
      .form-label {
        @apply block text-sm font-medium text-gray-700 mb-1;
      }
      
      /* Card styling for form sections */
      .card {
        @apply bg-white shadow rounded-lg p-6;
      }
    `}</style>
  );
};

export default FormStyles; 